const DEVICE_ORDER = ['desktop', 'mobile', 'app']

const DEVICE_LABELS = {
  desktop: 'Desktop',
  mobile: 'Mobile',
  app: 'App'
}

export function normalizeDeviceArray(value) {
  const tokens = (Array.isArray(value) ? value : String(value || '').split(/[-,]/))
    .map((token) => String(token).trim().toLowerCase())
    .filter(Boolean)

  const uniqueTokens = [...new Set(tokens)]
  const orderedTokens = DEVICE_ORDER.filter((device) => uniqueTokens.includes(device))
  const extraTokens = uniqueTokens.filter((device) => !DEVICE_ORDER.includes(device))

  return [...orderedTokens, ...extraTokens]
}

export function buildDeviceArrayFromFlags(flags = {}) {
  if (flags.device) {
    return normalizeDeviceArray(flags.device)
  }

  return normalizeDeviceArray([
    flags.desktop ? 'desktop' : null,
    flags.mobile ? 'mobile' : null,
    flags.app ? 'app' : null
  ])
}

export function getDeviceOptions() {
  return DEVICE_ORDER.map((value) => ({
    text: DEVICE_LABELS[value],
    value
  }))
}

export function formatDeviceDisplay(value, separator = '-') {
  return normalizeDeviceArray(value).join(separator)
}

export default {
  normalizeDeviceArray,
  buildDeviceArrayFromFlags,
  getDeviceOptions,
  formatDeviceDisplay
}